(function () {
    var MODAL_ID = 'whatsapp-modal';

    var LINKS = {
        google: 'https://api.whatsapp.com/send/?phone=%2B5511976737253&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+o+programa%21&type=phone_number&app_absent=0'
    };

    var selectedOption = null;

    function ensureModal() {
        if (document.getElementById(MODAL_ID)) {
            return document.getElementById(MODAL_ID);
        }

        var modal = document.createElement('div');
        modal.id = MODAL_ID;
        modal.className = 'whatsapp-modal-backdrop';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-hidden', 'true');
        modal.innerHTML =
            '<div class="whatsapp-modal">' +
                '<button type="button" class="whatsapp-modal-close" data-whatsapp-close aria-label="Fechar">&times;</button>' +
                '<h3>Escolha como continuar</h3>' +
                '<div class="whatsapp-modal-options">' +
                    '<button type="button" class="whatsapp-option" data-whatsapp-option="google">Google</button>' +
                '</div>' +
                '<button type="button" class="whatsapp-confirm" data-whatsapp-confirm disabled>Continuar no WhatsApp</button>' +
            '</div>';

        document.body.appendChild(modal);
        bindModal(modal);
        return modal;
    }

    function openModal(event, modal) {
        if (event) {
            event.preventDefault();
        }
        selectedOption = null;
        var confirm = modal.querySelector('[data-whatsapp-confirm]');
        if (confirm) {
            confirm.setAttribute('disabled', '');
        }
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('active');
    }

    function closeModal(modal) {
        if (!modal) {
            return;
        }
        modal.setAttribute('aria-hidden', 'true');
        modal.classList.remove('active');
        selectedOption = null;
        var confirm = modal.querySelector('[data-whatsapp-confirm]');
        if (confirm) {
            confirm.setAttribute('disabled', '');
        }
        var active = modal.querySelector('.whatsapp-option.active');
        if (active) {
            active.classList.remove('active');
        }
    }

    function bindModal(modal) {
        modal.addEventListener('click', function (event) {
            if (event.target.closest('[data-whatsapp-close]')) {
                closeModal(modal);
                return;
            }

            var option = event.target.closest('[data-whatsapp-option]');
            if (option) {
                var active = modal.querySelector('.whatsapp-option.active');
                if (active) {
                    active.classList.remove('active');
                }
                option.classList.add('active');
                selectedOption = option.getAttribute('data-whatsapp-option');

                var confirm = modal.querySelector('[data-whatsapp-confirm]');
                if (confirm) {
                    confirm.removeAttribute('disabled');
                }
                return;
            }

            if (event.target.closest('[data-whatsapp-confirm]')) {
                if (selectedOption && LINKS[selectedOption]) {
                    window.open(LINKS[selectedOption], '_blank');
                    closeModal(modal);
                }
            }
        });
    }

    function init() {
        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('.js-whatsapp-trigger');
            if (!trigger) {
                return;
            }

            if (Object.keys(LINKS).length > 1) {
                var modal = ensureModal();
                openModal(event, modal);
            } else if (Object.keys(LINKS).length === 1) {
                event.preventDefault();
                window.open(LINKS[Object.keys(LINKS)[0]], '_blank');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();